import script from "./UeberpruefenStep.vue?vue&type=script&setup=true&lang=js"
export * from "./UeberpruefenStep.vue?vue&type=script&setup=true&lang=js"

import "./UeberpruefenStep.vue?vue&type=style&index=0&id=f9bf18f0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9bf18f0"]])

export default __exports__